import { WORKFLOW_ACTIONS } from 'modules/workflows/constants';

export const MEMBERSHIP_ACTION_OPTIONS = [
  {
    id: 'Add user to...',
    value: WORKFLOW_ACTIONS.ADD_CONTACT,
    name: 'Add user to...',
  },
  {
    id: 'Remove user from...',
    value: WORKFLOW_ACTIONS.REMOVE_CONTACT,
    name: 'Remove user from...',
  },
];

export const LIST_MEMBERSHIP_EDITOR_TEST_ID = 'modify-list-membership-editor';
export const SET_MEMBERSHIP_ACTION_ID = 'radio-list-set-membership-action';
export const SET_ADD_CONTACT_ID = `radio-list-option-${MEMBERSHIP_ACTION_OPTIONS[0]?.id}`;
export const SET_REMOVE_CONTACT_ID = `radio-list-option-${MEMBERSHIP_ACTION_OPTIONS[1]?.id}`;
export const LIST_MEMBERSHIP_SELECT_ID = 'list-membership-select';
export const LIST_MEMBERSHIP_MULTI_SELECT_ID = 'multi-select-list-membership-select';
export const VIEW_SELECTED_LIST_LINK_ID = 'view-selected-list-link';
